module.exports = __webpack_public_path__ + "img/logo.509b0884.png";